/**
 * 教学视频
 */

import * as React from 'react'
import { Button } from 'antd'
import MenuItem from './MenuItem'
import styles from './index.module.less'

const { useMemo, useState } = React

export default function Guide({ dataSource, onCancel, translateTxt }: any) {
  const [current, setCurrent] = useState(0)

  const lastIndex: number = useMemo(() => {
    if (!Array.isArray(dataSource)) return 0
    return dataSource.length - 1
  }, [dataSource])

  const lastItem: any = dataSource?.[lastIndex] || {}
  const currentItem: any = dataSource?.[current] || {}

  const handleNext = () => {
    if (current < lastIndex) {
      setCurrent(current + 1)
    }
  }

  return (
    <div className={styles.body}>
      <div className={styles.header}>{translateTxt('components:t157')}</div>
      <div className={styles.container}>
        <div className={styles.menus}>
          {dataSource.map((item: any, index: number) => (
            <MenuItem
              key={item.id}
              {...item}
              active={current === index}
              onChange={() => setCurrent(index)}
            />
          ))}
        </div>
        <div className={styles.main}>
          <video
            key={currentItem.id}
            className="video-player"
            poster={currentItem.poster}
            src={currentItem.src}
            controls
            // loop
            autoPlay
          />
        </div>
      </div>
      <div className={styles.footer}>
        {lastItem.id === currentItem.id ? (
          <Button type="primary" onClick={onCancel}>
            {translateTxt('components:t158')}
          </Button>
        ) : (
          <Button type="primary" onClick={handleNext}>
            {translateTxt('components:t107')}
          </Button>
        )}
      </div>
    </div>
  )
}
